module.exports = __webpack_public_path__ + "img/wechat_round.7cb9ef35.svg";